import { defineComponent as b, createElementBlock as i, createCommentVNode as p, openBlock as a, Fragment as m, withModifiers as n, normalizeClass as o, toDisplayString as s, capitalize as r } from "vue";
const d = ["href"], h = ["href"], y = /* @__PURE__ */ b({
  __name: "HeaderItemTab",
  props: {
    tab: {},
    isEditable: { type: Boolean },
    isMobile: { type: Boolean },
    linkIsActive: { type: Function },
    resolveInternalLinks: { type: Function }
  },
  emits: ["navigate"],
  setup(k) {
    return (e, t) => e.tab.show || e.isEditable ? (a(), i(m, { key: 0 }, [
      e.isMobile ? (a(), i("a", {
        key: 0,
        class: o(["header-item-link", {
          "header-item-active": e.linkIsActive(e.tab),
          "header-item-ghost": !e.tab.show
        }]),
        href: e.resolveInternalLinks(e.tab),
        onClick: t[0] || (t[0] = n((l) => e.$emit("navigate", e.tab.uid, e.tab.type), ["prevent"]))
      }, s(e.tab.title || r(e.tab.type)), 11, d)) : (a(), i("a", {
        key: 1,
        class: o(["header-item-link", {
          "header-item-active": e.linkIsActive(e.tab),
          "header-item-ghost": !e.tab.show
        }]),
        href: e.resolveInternalLinks(e.tab),
        onClick: t[1] || (t[1] = n((l) => e.$emit("navigate", e.tab.uid, e.tab.type), ["prevent"]))
      }, s(e.tab.title || r(e.tab.type)), 11, h))
    ], 64)) : p("", !0);
  }
});
export {
  y as default
};
